/// <amd-module name="RMWidgets/DeploymentStatusWidget/Clients/RestClient/Build" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   releasemanagement\web\extensions\release\vss-releasemanagement-web\widgets\deployment-status-widget\clients\build.genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Build from "RMWidgets/DeploymentStatusWidget/Clients/Contracts/Build";

export interface IBuildRestClient extends IVssRestClient {
    /**
     * Gets a definition, optionally at a specific revision.
     * 
     * @param project - Project ID or project name
     * @param definitionId - The ID of the definition.
     * @param revision - The revision number to retrieve. If this is not specified, the latest version will be returned.
     * @param minMetricsTime - If specified, indicates the date from which metrics should be included.
     * @param propertyFilters - A comma-delimited list of properties to include in the results.
     * @param includeLatestBuilds - 
     */
    getDefinition(project: string, definitionId: number, revision?: number, minMetricsTime?: Date, propertyFilters?: string[], includeLatestBuilds?: boolean): Promise<Build.BuildDefinition>;
}

class BuildRestClient extends RestClientBase implements IBuildRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Gets a definition, optionally at a specific revision.
     * 
     * @param project - Project ID or project name
     * @param definitionId - The ID of the definition.
     * @param revision - The revision number to retrieve. If this is not specified, the latest version will be returned.
     * @param minMetricsTime - If specified, indicates the date from which metrics should be included.
     * @param propertyFilters - A comma-delimited list of properties to include in the results.
     * @param includeLatestBuilds - 
     */
    public async getDefinition(
        project: string,
        definitionId: number,
        revision?: number,
        minMetricsTime?: Date,
        propertyFilters?: string[],
        includeLatestBuilds?: boolean
        ): Promise<Build.BuildDefinition> {

        const queryValues: any = {
            revision: revision,
            minMetricsTime: minMetricsTime,
            propertyFilters: propertyFilters && propertyFilters.join(","),
            includeLatestBuilds: includeLatestBuilds
        };

        return this.beginRequest<Build.BuildDefinition>({
            apiVersion: "5.0-preview.7",
            routeTemplate: "{project}/_apis/build/definitions/{definitionId}",
            routeValues: {
                project: project,
                definitionId: definitionId
            },
            queryParams: queryValues
        });
    }

}

export const BuildClientName = "dsw.build.client.IBuildRestClient";

export function getBuildClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IBuildRestClient {
    return pageContext.getRestClient<IBuildRestClient>(BuildClientName, options);
}

RestClients.add(BuildClientName, { 
    factory: BuildRestClient,
    options: {
        resourceAreaId: "965220d5-5bb9-42cf-8d67-9b146df2a5a4",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
